import "./LocalSeoConsultantSunderland.module.css";
import Header from "@/reusable_sections/Header";
import LocalAuthorityHero from "./sections/LocalAuthorityHero";
import Editorial from "./sections/Editorial";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import Sectors from "./sections/Sectors";
import Methodology from "./sections/Methodology";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import Sunderland from "./sections/Sunderland";
import Consultation from "./sections/Consultation";
import Localseo from "./sections/Localseo";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantSunderlandPage() {
  return <div>
      <Header />
      <LocalAuthorityHero />
      <Editorial />
      <Casestudyshowcase />
      <Sectors />
      <Methodology />
      <ConsultantBenefits />
      <Sunderland />
      <Consultation />
      <Localseo />
      <Faq />
      <Footer />
    </div>;
}